import extend from "extend";

export interface Config {
	apiHost: string;
	managerHost: string;
	logRocketProjectName: string;
	intercomAppId: string;
	environment: Environment;
	firebaseConfig: {
		apiKey: string;
		authDomain: string;
		projectId: string;
		storageBucket: string;
		messagingSenderId: string;
		appId: string;
		measurementId: string;
	};
	fliptConfig: {
		url: string;
		clientToken: string;
	};
}

const getEnvironmentFromUrl = (): Environment => {
	const hostname = window.location.hostname;

	if (hostname === "respond.vurvey.app") {
		return "prod";
	}

	if (hostname === "respond.staging.vurvey.dev") {
		return "staging";
	}

	if (hostname === "respond.development.env.vurvey.dev") {
		return "dev";
	}

	if (hostname === "localhost" || hostname === "127.0.0.1") {
		return "local";
	}

	return "staging";
};

export type Environment = "dev" | "test" | "staging" | "prod" | "local";
const base: Partial<Config> = {
	apiHost: "https://localhost:3000",
	managerHost: "https://localhost:5050",
	environment: "dev",
	/*
	        Using a single client id (the "manager" id until we rename) so
	        that we don't need to login seperately for responder.
	*/
	firebaseConfig: {
		apiKey: "AIzaSyBo3WI_YKn6yr0H6Dl_8me9N9u6_Wciskg",
		authDomain: "fir-auth-cdeac.firebaseapp.com",
		projectId: "fir-auth-cdeac",
		storageBucket: "fir-auth-cdeac.appspot.com",
		messagingSenderId: "1046730303135",
		appId: "1:1046730303135:web:d0c03cca3e99bba26564aa",
		measurementId: "G-1M077C3JF7",
	},
	fliptConfig: {
		url: "https://flipt-staging.vurvey.dev",
		clientToken: "3be4a3e7379f48e6932299f0b3b5eae2",
	},
};

const envs: {[key in Environment]: Partial<Config>} = {
	local: {},
	dev: {
		apiHost: "https://api.development.env.vurvey.dev",
		managerHost: "https://development.env.vurvey.dev",
		logRocketProjectName: "vurvey/vurvey-responder-dev",
		environment: "dev",
		fliptConfig: {
			url: "https://flipt-staging.vurvey.dev",
			clientToken: "3be4a3e7379f48e6932299f0b3b5eae2",
		},
	},
	test: {
		apiHost: "https://api2.vurvey.dev",
		managerHost: "https://vurvey.dev",
		logRocketProjectName: "vurvey/vurvey-responder-dev",
		intercomAppId: "ismzpdxk",
	},
	staging: {
		apiHost: "https://api-staging.vurvey.dev",
		managerHost: "https://staging.vurvey.dev",
		logRocketProjectName: "vurvey/vurvey-responder-dev",
		environment: "staging",
		fliptConfig: {
			url: "https://flipt-staging.vurvey.dev",
			clientToken: "3be4a3e7379f48e6932299f0b3b5eae2",
		},
	},
	prod: {
		apiHost: "https://api.vurvey.app",
		managerHost: "https://vurvey.app",
		logRocketProjectName: "vurvey/vurvey-responder-prod-trcyk",
		intercomAppId: "ismzpdxk",
		environment: "prod",
		firebaseConfig: {
			apiKey: "AIzaSyAq2XOtJ4KBoxSUeQ8pQLRUNq2NDr2fO0U",
			authDomain: "fir-prod-290cd.firebaseapp.com",
			projectId: "fir-prod-290cd",
			storageBucket: "fir-prod-290cd.appspot.com",
			messagingSenderId: "536194458678",
			appId: "1:536194458678:web:89f091633750ced8886497",
			measurementId: "G-NCMJ36GX6C",
		},
		fliptConfig: {
			url: "https://flipt.vurvey.app",
			clientToken: "a16ad3149aa04e649c69631286602c12",
		},
	},
};

if (import.meta.env.DEV && import.meta.env.REACT_APP_API_ENV) {
	const requestedEnv = import.meta.env.REACT_APP_API_ENV as Environment;
	if (requestedEnv in envs) {
		envs.local = envs[requestedEnv];
	} else {
		console.warn(`Invalid REACT_APP_API_ENV: ${requestedEnv}. Using default local config.`);
	}
}

const env = envs[getEnvironmentFromUrl()];
const config: Config = extend({}, base, env);

export default config;
export {config};
